export default {
  Accordion: {
    w: 12,
    h: 10
  },
  Bar: {
    w: 12,
    h: 12
  },
  Button: {
    w: 6,
    h: 2
  },
  Calendar: {
    w: 24,
    h: 24
  },
  Carousel: {
    w: 24,
    h: 24
  },
  Conditional: {
    w: 12,
    h: 12
  },
  ConditionalItem: {
    w: 12,
    h: 12
  },
  Container: {
    w: 12,
    h: 5
  },
  Content: {
    w: 48,
    h: 40
  },
  Email: {
    w: 24,
    h: 24
  },
  Field: {
    w: 4,
    h: 2
  },
  Frame: {
    w: 12,
    h: 12
  },
  Highlight: {
    w: 6,
    h: 5
  },
  HTML: {
    w: 12,
    h: 12
  },
  IFrame: {
    w: 24,
    h: 10
  },
  Image: {
    w: 10,
    h: 4
  },
  Label: {
    w: 8,
    h: 3
  },
  Line: {
    w: 12,
    h: 12
  },
  Link: {
    w: 6,
    h: 2
  },
  List: {
    w: 24,
    h: 12
  },
  ListView: {
    w: 24,
    h: 20
  },
  Navigation: {
    w: 48,
    h: 3
  },
  Pie: {
    w: 12,
    h: 12
  },
  Repeater: {
    w: 12,
    h: 12
  },
  ReportSelectors: {
    w: 12,
    h: 12
  },
  RichTextEditor: {
    w: 24,
    h: 12
  },
  Search: {
    w: 24,
    h: 4
  },
  Form: {
    w: 16,
    h: 10
  },
  StatusBar: {
    w: 12,
    h: 4
  },
  Tab: {
    w: 48,
    h: 12
  },
  Tabs: {
    w: 24,
    h: 24
  },
  FileUpload: {
    w: 12,
    h: 4
  },
  Wizard: {
    w: 24,
    h: 20
  }
}
